import {
  FranchiseDashboardContent,
  FranchiseOcPage,
  FranchiseStoresPage,
} from '@/app/features/franchise-admin/pages';
import ScopedDataPage from '@/app/pages/ScopedDataPage';
import { franchiseAdminNavItems, type AdminNavItem, type AdminSurfaceConfig } from '@/app/surface';

export const surfaceConfig: AdminSurfaceConfig = {
  surface: 'franchise_admin',
  allowedRole: 'super_admin',
  title: 'Octopus 프랜차이즈 관리자',
  shortTitle: 'Franchise Admin',
  badge: 'FR',
  loginTitle: '프랜차이즈 관리자 로그인',
  loginDescription: '프랜차이즈 매장 현황, 고객 활동, OC 요청을 확인합니다.',
  usernameLabel: '관리자 ID',
  usernamePlaceholder: 'franchise_admin',
  homePath: '/',
  navItems: franchiseAdminNavItems,
};

export function getSurfaceRouteElement(item: AdminNavItem, config: AdminSurfaceConfig) {
  switch (item.path) {
    case '/stores':
      return <FranchiseStoresPage />;
    case '/oc':
      return <FranchiseOcPage />;
    default:
      return <ScopedDataPage item={item} surfaceConfig={config} />;
  }
}

export function getSurfaceDashboardElement() {
  return <FranchiseDashboardContent />;
}
